//@ts-check
import { SearchIcon } from "@chakra-ui/icons";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/input";
import React from "react";

export const filter = (value, data) => {
  let _all = [];
  if (value !== "") {
    _all = data.filter((item) => {
      const lc = item.node.name.toLocaleLowerCase("tr-TR");
      const filter = value.toLocaleLowerCase("tr-TR");
      return lc.includes(filter);
    });
  } else {
    _all = data;
  }
  return _all;
};

const Search = ({ value, setValue }) => {
  const handleChange = (event) => setValue(event.target.value);
  return (
    <InputGroup
      borderWidth="thin"
      borderColor="gray.100"
      borderRadius="md"
      variant="Filled"
      focusBorderColor="red.500"
      autoFocus
      gridColumnStart="1"
      gridColumnEnd="-1"
      mb="2"
    >
      <InputLeftElement pointerEvents="none" children={<SearchIcon color="gray.600" />} />
      <Input placeholder="Parça Arayın.." onChange={handleChange} value={value} />
    </InputGroup>
  );
};

export default Search;
